import { queryGet, queryPost } from '@/api/apiConfig';

export default {
  getCategories () {
    return queryGet('/api/app/patchCategory/fullList');
  },

  getSizes () {
    return queryGet('/api/app/patchCategorySize?maxResultCount=1000');
  },

  getCategory ({ categoryId, orderId, schoolId }) {
    if (orderId) {
      return queryGet(`/api/app/patchCategory/${categoryId}/byOrderId/${orderId}`);
    }
    if (schoolId) {
      return queryGet(`/api/app/patchCategory/${categoryId}/bySchoolId/${schoolId}`);
    }

    return queryGet(`/api/app/patchCategory/${categoryId}`);
  },

  async getPatchesByCategory (categoryId, orderId, schoolId) {
    if (orderId) {
      return queryGet(`/api/app/patch/patchesByCategoryId?categoryId=${categoryId}&orderId=${orderId}`);
    }
    if (schoolId) {
      return queryGet(`/api/app/patch/patchesByCategoryId?categoryId=${categoryId}&schoolId=${schoolId}`);
    }
    return queryGet(`/api/app/patch/patchesByCategoryId?categoryId=${categoryId}`);
  },

  async getPatchesBySubCategory ({ categoryId, orderId, schoolId }) {
    if (orderId) {
      return queryGet(`/api/app/patch/patchesBySubCategoryId?categoryId=${categoryId}&orderId=${orderId}`);
    }
    if (schoolId) {
      return queryGet(`/api/app/patch/patchesBySubCategoryId?categoryId=${categoryId}&schoolId=${schoolId}`);
    }
    return queryGet(`/api/app/patch/patchesBySubCategoryId?categoryId=${categoryId}`);
  },

  getPatchById (id) {
    return queryGet(`api/app/patch/${id}`);
  },

  saveApartPatch (data) {
    console.log('data: ', data);
    return queryPost('/api/app/patch/design', data);
  }
};
